import axios, { AxiosRequestConfig } from 'axios'
import { getPathRegion } from 'models/location/selectors'

interface Completion {
    completion: {
        text: string
    }
}
interface Category {
    category: {
        name: string
        key: string
    }
}

type SearchCompletionResponseItem = (Completion | Category)

interface Response {
    searchBox: {
        universal: SearchCompletionResponseItem[]
    }
}

const SIK_SEARCH_BASE_URL = 'https://sik.search.blue.cdtapps.com'
export const getSearchCompletions = (searchTerm: string) => {
    const region = getPathRegion()
    const url = `${SIK_SEARCH_BASE_URL}/${region}/search-box?range=GEOMAGICAL&q=${searchTerm}`
    const config: AxiosRequestConfig = {
        headers: {
            Accept: `application/json`,
            'Content-type': `application/json`,
        },
        method: `get`,
        url,
    }
    return axios.request<Response>(config)
}

export default getSearchCompletions
